import { EMAIL_FROM_MARKETING_SITE } from 'app-constants'
import removeDuplicateQueryParams from 'utils/sourceAttributes'
import { isClickId, isProgramReferral } from './queryParams'
import { Location } from 'history'

export type FormValues = {
  email: string | string[]
  password: string
  usResident: boolean
  partnerDisclosure?: boolean
}

function emailCheck(location: Location) {
  const parsed = removeDuplicateQueryParams(location.search)

  const emailFromMarketingSite = document.cookie
    .split(';')
    .filter((cookie) => cookie.includes(EMAIL_FROM_MARKETING_SITE))
    .toString()
    .split('=')
    .pop()

  if (emailFromMarketingSite) {
    return emailFromMarketingSite
  } else if (parsed.email) {
    return parsed.email
  }

  return ''
}

export const getInitialValues = (location: Location, earlyCustomerEmail?: string) => {
  const values: FormValues = {
    email: earlyCustomerEmail || emailCheck(location),
    password: '',
    usResident: false,
  }

  // If this is referred by affiliate, add default for disclosure property
  if (isClickId() || isProgramReferral()) {
    values.partnerDisclosure = false
  }

  return values
}
